import { useEffect, useRef } from "react";

/**
 * Adds "is-visible" class when element enters viewport.
 * Use together with the `.reveal` CSS utility.
 */
export default function useReveal() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );

    const nodes = el.querySelectorAll(".reveal");
    nodes.forEach((n) => io.observe(n));

    return () => io.disconnect();
  }, []);

  return ref;
}
